import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Environment = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '10%']);
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '-15%']);
  const points = ['la tolérance de votre peau', 'votre confort pendant la séance', 'la sécurité de chaque application laser', 'la transparence sur les résultats'];
  return <section ref={ref} id="environment" className="py-32 md:py-48 bg-brand-darker overflow-hidden" data-id="element-43">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-44">
        {/* Text-Led Header */}
        <div className="mb-20 lg:mb-32" data-id="element-45">
          <ScrollReveal blur scale duration={1.2} data-id="element-46">
            <h2 className="text-5xl md:text-7xl lg:text-[6rem] font-black text-brand-light mb-8 tracking-tighter leading-[1.02] text-balance" data-id="element-47">
              Un Environnement Hygiénique et Professionnel
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.2} blur data-id="element-48">
            <h3 className="text-2xl md:text-3xl font-medium text-brand-gray tracking-tight" data-id="element-49">
              Sécurité, Confort et Transparence
            </h3>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start" data-id="element-50">
          {/* Bullets Content (Left) */}
          <motion.div style={{
          y: yText
        }} className="lg:col-span-7" data-id="element-51">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-10" data-id="element-52">
              {points.map((point, index) => <div key={index} className="flex flex-col space-y-4" data-id="element-53">
                  <motion.div initial={{
                scaleX: 0
              }} whileInView={{
                scaleX: 1
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                duration: 0.8,
                delay: 0.3 + index * 0.1,
                ease: [0.16, 1, 0.3, 1]
              }} className="w-12 h-[1px] bg-brand-light/30 origin-left" data-id="element-54" />
                  <ScrollReveal delay={0.4 + index * 0.1} blur direction="none" distance={0} data-id="element-55">
                    <p className="text-xl text-brand-light font-light leading-relaxed" data-id="element-56">
                      {point}
                    </p>
                  </ScrollReveal>
                </div>)}
            </div>

            <ScrollReveal delay={0.7} blur data-id="element-57">
              <p className="text-xl md:text-2xl text-brand-gray/80 font-light leading-relaxed mt-20 max-w-2xl" data-id="element-58">
                De la première consultation jusqu'à la dernière séance, je vous
                offre des explications claires, des attentes réalistes et un
                accompagnement personnalisé.
              </p>
            </ScrollReveal>
          </motion.div>

          {/* Inset Image (Right) */}
          <motion.div style={{
          y: yImage
        }} className="lg:col-span-5 relative h-[50vh] lg:h-[70vh] w-full mt-12 lg:mt-0" data-id="element-59">
            <ScrollReveal clipReveal="top" duration={1.5} className="h-full w-full" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/k8gz3yZyWgvaCAXRy24LsG/IMG_2687-PROOF-THOMAS-MASOTTI.jpg" alt="Gros plan du traitement laser sur un tatouage au bras dans un environnement hygiénique et professionnel" className="w-full h-full object-cover grayscale-[20%]" loading="lazy" data-id="element-61" />
            </ScrollReveal>
          </motion.div>
        </div>
      </div>
    </section>;
};